(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elfine-colour-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elfine-colour-family')) {
    const requests = new Map();
    async function readIndex(endpoint) {
      const products = new Map();
      const visited = new Set();
      let url = new URL(endpoint, window.location.origin);
      if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') {
        url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      }
      while (url) {
        if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid colour index page');
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Colour index unavailable');
        const payload = await response.json();
        if (payload.version !== 1 || !Array.isArray(payload.products)) throw new Error('Invalid colour index');
        for (const product of payload.products) {
          if (product.id && product.url) products.set(String(product.id), product);
        }
        if (payload.next) {
          const next = new URL(payload.next, url);
          next.searchParams.set('view', 'elfine-colour-index');
          const preview = url.searchParams.get('preview_theme_id');
          if (preview) next.searchParams.set('preview_theme_id', preview);
          url = next;
        } else {
          url = null;
        }
      }
      const edges = new Map([...products.keys()].map(id => [id, new Set()]));
      for (const [id, product] of products) {
        for (const reference of product.links || []) {
          const target = String(reference);
          if (target === id || !products.has(target)) continue;
          edges.get(id).add(target);
          edges.get(target).add(id);
        }
      }
      return { products, edges };
    }
    function getIndex(endpoint) {
      if (!requests.has(endpoint)) {
        const request = readIndex(endpoint).catch(error => {
          requests.delete(endpoint);
          throw error;
        });
        requests.set(endpoint, request);
      }
      return requests.get(endpoint);
    }
    customElements.define('elfine-colour-family', class extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        try {
          const { products, edges } = await getIndex(this.dataset.indexUrl);
          if (!this.isConnected) return;
          const currentId = this.dataset.productId;
          if (!products.has(currentId)) return;
          const ids = new Set([currentId]);
          const queue = [currentId];
          for (let index = 0; index < queue.length; index++) {
            for (const id of edges.get(queue[index]) || []) {
              if (!ids.has(id)) {
                ids.add(id);
                queue.push(id);
              }
            }
          }
          if (ids.size < 2) return;
          const current = products.get(currentId);
          const wrapper = document.createElement('div');
          wrapper.className = 'elfine-colour-links elfine-colour-links--' + (this.dataset.context === 'product' ? 'product' : 'card');
          if (this.dataset.context === 'product') {
            const label = document.createElement('p');
            label.className = 'elfine-colour-links__label';
            label.append(this.dataset.label + ' ');
            const name = document.createElement('strong');
            name.textContent = current.colour || current.title;
            label.append(name);
            wrapper.append(label);
          }
          const list = document.createElement('div');
          list.className = 'elfine-colour-links__items';
          list.setAttribute('role', 'list');
          list.setAttribute('aria-label', this.dataset.availableLabel);
          for (const id of ids) {
            const item = products.get(id);
            const link = document.createElement('a');
            const itemUrl = new URL(item.url, window.location.origin);
            if (itemUrl.origin !== window.location.origin) continue;
            link.className = 'elfine-colour-link' + (id === currentId ? ' is-active' : '');
            link.href = itemUrl.href;
            link.title = item.colour || item.title;
            link.setAttribute('aria-label', this.dataset.viewLabel.replace('__COLOUR__', item.colour || item.title));
            link.setAttribute('role', 'listitem');
            if (id === currentId) link.setAttribute('aria-current', 'page');
            if (item.image) {
              const image = document.createElement('img');
              image.src = item.image;
              image.alt = item.colour || item.title;
              image.width = 160;
              image.height = 160;
              image.loading = 'lazy';
              link.append(image);
            } else {
              const label = document.createElement('span');
              label.textContent = item.colour || item.title;
              link.append(label);
            }
            list.append(link);
          }
          wrapper.append(list);
          this.replaceChildren(wrapper);
          this.dataset.loaded = 'true';
        } catch {
          this.dataset.loaded = 'false';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
